/*jshint -W069 */
/**
 *
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
  'use strict';

  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelperNew.js').customRequest;
  var mergeQueryParams = require('./requestHelperNew.js').mergeQueryParams;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : settingsInstance.baseApiNewUrl;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  /**
   * Filter autocomplete teryt gmin
   * @method
   * @name Api#getDanePrgTerytGminaFilter
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.filter_str - Token
   * @param {string} parameters.control - Token
   */
  Api.prototype.getDanePrgTerytGminaFilter = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/dane_prg/teryt_gmina_filter',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['filter_str'] !== undefined) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['filter_str'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: filter_str'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Usuń zgloszenia_rozbieznosci
   * @method
   * @name Api#deleteZgloszeniaRozbieznosci
   * @param {object} parameters - method options and parameters
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   */
  Api.prototype.deleteZgloszeniaRozbieznosci = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zgloszenia_rozbieznosci',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'DELETE',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz zgloszenia_rozbieznosci
   * @method
   * @name Api#getZgloszeniaRozbieznosci
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
   * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
   * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
   * @param {boolean} parameters.desc - Czy sortowanie zstępne
   * @param {string} parameters.filter_numer - Treść filtra numeru
   * @param {string} parameters.filter_user_str - Filter string użytkownika
   * @param {string} parameters.filter_teryt_str - Filter nazwy terytu
   * @param {string} parameters.teryt - Filter terytu
   * @param {string} parameters.status - Status
   * @param {number} parameters.data_zgloszenia_od - Data (unix)
   * @param {number} parameters.data_zgloszenia_do - Data (unix)
   * @param {number} parameters.data_zamkniecia_od - Data (unix)
   * @param {number} parameters.data_zamkniecia_do - Data (unix)
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getZgloszeniaRozbieznosci = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zgloszenia_rozbieznosci',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['page_number'] !== undefined) {
      queryParameters['page_number'] = parameters['page_number'];
    }

    if (parameters['items_per_page'] !== undefined) {
      queryParameters['items_per_page'] = parameters['items_per_page'];
    }

    if (
      parameters['order_by'] !== undefined &&
      parameters['order_by'] !== '' &&
      parameters['order_by'] !== null
    ) {
      queryParameters['order_by'] = parameters['order_by'];
    }

    if (parameters['desc'] !== undefined) {
      queryParameters['desc'] = parameters['desc'];
    }

    if (
      parameters['filter_numer'] !== undefined &&
      parameters['filter_numer'] !== '' &&
      parameters['filter_numer'] !== null
    ) {
      queryParameters['filter_numer'] = parameters['filter_numer'];
    }

    if (
      parameters['filter_user_str'] !== undefined &&
      parameters['filter_user_str'] !== '' &&
      parameters['filter_user_str'] !== null
    ) {
      queryParameters['filter_user_str'] = parameters['filter_user_str'];
    }

    if (
      parameters['filter_teryt_str'] !== undefined &&
      parameters['filter_teryt_str'] !== '' &&
      parameters['filter_teryt_str'] !== null
    ) {
      queryParameters['filter_teryt_str'] = parameters['filter_teryt_str'];
    }

    if (
      parameters['teryt'] !== undefined &&
      parameters['teryt'] !== '' &&
      parameters['teryt'] !== null
    ) {
      queryParameters['teryt'] = parameters['teryt'];
    }

    if (
      parameters['status'] !== undefined &&
      parameters['status'] !== '' &&
      parameters['status'] !== null
    ) {
      queryParameters['status'] = parameters['status'];
    }

    if (
      parameters['data_zgloszenia_od'] !== undefined &&
      parameters['data_zgloszenia_od'] !== '' &&
      parameters['data_zgloszenia_od'] !== null
    ) {
      queryParameters['data_zgloszenia_od'] = parameters['data_zgloszenia_od'];
    }

    if (
      parameters['data_zgloszenia_do'] !== undefined &&
      parameters['data_zgloszenia_do'] !== '' &&
      parameters['data_zgloszenia_do'] !== null
    ) {
      queryParameters['data_zgloszenia_do'] = parameters['data_zgloszenia_do'];
    }

    if (
      parameters['data_zamkniecia_od'] !== undefined &&
      parameters['data_zamkniecia_od'] !== '' &&
      parameters['data_zamkniecia_od'] !== null
    ) {
      queryParameters['data_zamkniecia_od'] = parameters['data_zamkniecia_od'];
    }

    if (
      parameters['data_zamkniecia_do'] !== undefined &&
      parameters['data_zamkniecia_do'] !== '' &&
      parameters['data_zamkniecia_do'] !== null
    ) {
      queryParameters['data_zamkniecia_do'] = parameters['data_zamkniecia_do'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Dodaj rozbieznosc
   * @method
   * @name Api#postZgloszeniaRozbieznosci
   * @param {object} parameters - method options and parameters
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   */
  Api.prototype.postZgloszeniaRozbieznosci = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zgloszenia_rozbieznosci',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];
    headers['Content-Type'] = ['application/json'];

    if (parameters['form'] !== undefined) {
      form = parameters['form'];
    }
    if (parameters['form'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: form'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Usuń zgloszenia_rozbieznosci
   * @method
   * @name Api#deleteZgloszeniaRozbieznosciById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID
   * @param {string} parameters.token - Token
   */
  Api.prototype.deleteZgloszeniaRozbieznosciById = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zgloszenia_rozbieznosci/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'DELETE',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz rozbieznosc
   * @method
   * @name Api#getZgloszeniaRozbieznosciById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.id - ID
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getZgloszeniaRozbieznosciById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zgloszenia_rozbieznosci/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Dodaj komentarz
   * @method
   * @name Api#postZgloszeniaRozbieznosciByIdKomentarz
   * @param {object} parameters - method options and parameters
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   * @param {string} parameters.id - ID
   */
  Api.prototype.postZgloszeniaRozbieznosciByIdKomentarz = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zgloszenia_rozbieznosci/{id}/komentarz',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Dodaj komentarz
   * @method
   * @name Api#postZgloszeniaRozbieznosciByIdWyslijEmail
   * @param {object} parameters - method options and parameters
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   * @param {string} parameters.id - ID
   */
  Api.prototype.postZgloszeniaRozbieznosciByIdWyslijEmail = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zgloszenia_rozbieznosci/{id}/wyslij_email',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  return Api;
})();

exports.Api = Api;
